import {
  NON_MEMBER_PORTAL_NAMES,
  MEMBER_PORTAL_NAMES,
} from '../data/constants';

// This will pull the member portal name from the url and return it. It
// returns null if this is the non-portal version of the site.
const { __environment__ } = window;
export function usePortalName(): string | null {
  const hostName = window.location.hostname;

  // If we are doing development then check for an override of the portal
  // name in the runtimeConfig file.
  if (hostName === 'localhost') {
    return __environment__.REACT_APP_TEST_PORTAL_NAME || null;
  }

  const portalName = hostName.substring(0, hostName.indexOf('.'));
  return MEMBER_PORTAL_NAMES.includes(portalName) ? portalName : null;
}

// TODO This is a temporary workaround for testing until portal names are included in the database and apis
export function usePortalNameFromClientBC(clientBC: string): string {
  let portalName;
  switch (clientBC) {
    case 'DQ':
      portalName = 'dentaquest';
      break;
    case 'MVP':
      portalName = 'mvp';
      break;
    case 'AHC':
      portalName = 'ahc';
      break;
    case 'AHCADMIN':
      portalName = 'ahcadmin';
      break;
    default:
      portalName = 'transport';
      break;
  }

  return portalName;
}
